import React, { useEffect, useState } from 'react';
import { PhoneIcon } from 'lucide-react';
export const StickyContact = ({
  phoneNumber
}) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);
  return <div className={`fixed bottom-0 left-0 w-full p-4 md:hidden z-10 transition-all duration-500 transform ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-490">
      <a href={`tel:${phoneNumber}`} className="flex items-center justify-center gap-2 bg-[#111010] text-white py-3.5 px-5 rounded-lg shadow-lg w-full font-medium text-base transition-all duration-300 hover:shadow-xl active:scale-95" data-id="element-491">
        <PhoneIcon size={20} className="text-[#FCCA86]" data-id="element-492" />
        Direct contact opnemen
      </a>
    </div>;
};